
import { Vue, Component, Prop } from 'vue-property-decorator';
import XcqManuscriptFooter from './XcqManuscriptFooter.vue';
import TopTag from './TopTag.vue';

@Component({
  components: {
    XcqManuscriptFooter,
    TopTag,
  },
})
export default class XcqManuscriptNoImg extends Vue {
  @Prop({
    default: () => ({
      blockHeaderPic: '',
      blockName: '',
      blockBottomText: '',
      extText1: '',
      data: {},
      list: [],
    }),
  })
  blockInfo!: any;

  @Prop({ default: 349 }) width!: number;

  @Prop({ default: null }) blockDataInfo!: any;

  @Prop({ default: false }) showTop!: boolean;

  @Prop({ default: 0 }) topValue!: number;

  // 计算属性
  get dataInfo(): any {
    return this.blockDataInfo || this.blockInfo.data;
  }

  // 点击事件处理
  handleClick(info: any): void {
    this.$emit('clickItem', info.jump, info);
  }
}
